import React from 'react';
import '../../styles/components/AsperaMultiCheckbox.scss';
import { Checkbox } from '../Carbon';
/**
 * React Component
 *
 * The AsperaMultiCheckbox renders the multi checkbox form item
 *
 * @example
 * ```javascript
 * <AsperaMultiCheckbox />
 * ```
 */
export class AsperaMultiCheckbox extends React.Component {
    render() {
        const { className, dataAuto, labelText, items, id, disabled, onChange, invalid, invalidText, helperText } = this.props;
        return (React.createElement("div", { className: `aspera-multi-checkbox cds--form-item cds--checkbox-wrapper ${className ? className : ''}`, id: id, "data-auto": dataAuto },
            React.createElement("legend", { className: "cds--label" }, labelText),
            (items || []).map((item, index) => {
                return (React.createElement(Checkbox, { key: index, "data-auto": `aspera-multi-checkbox-${item.value}`, id: `aspera-multi-checkbox-${id}-${item.value}`, disabled: disabled, checked: item.checked || false, labelText: item.labelText || '', onChange: (_event, data) => {
                        item.checked = data.checked;
                        if (typeof onChange === 'function')
                            onChange(items);
                        this.setState({});
                    } }));
            }),
            (!!helperText && !invalid) && React.createElement("div", { className: "cds--form__helper-text helper-text" }, helperText),
            !!invalid && React.createElement("div", { className: "cds--form-requirement error-text" }, invalidText)));
    }
}
